import { registerBlockType } from '@wordpress/blocks';

import metadata from '../block.json';
import Edit from './Edit';
import './editor.scss';
import { skypeIcon } from './utils/icons';

registerBlockType(metadata, {
	icon: skypeIcon(24),

	// Build in Functions
	edit: Edit,

	save: () => null
});